module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carrier-activation"
  }, [_c('SimpleHeader', {
    attrs: {
      "productInfo": _vm.productInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carrier-activation-inner flexcenter"
  }, [(!_vm.isTakeOver) ? _c('div', {
    staticClass: "carrier-activation-controls flexcenter"
  }, [_c('button', {
    staticClass: "activate-carrier",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.activateCarrier()
      }
    }
  }, [_c('span', [_vm._v("アプリを新規に利用する")])]), _vm._v(" "), (_vm.message) ? _c('p', {
    staticClass: "carrier-activation-error-activate-carrier m0"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "activate-takeover",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeDisplay()
      }
    }
  }, [_c('span', [_vm._v("前の端末の学習情報を引き継ぐ")])])]) : _c('div', {
    staticClass: "carrier-activation-controls flexcenter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "takeovercode flexcenter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.takeOverCode),
      expression: "takeOverCode"
    }],
    staticClass: "carrier-activation-text",
    attrs: {
      "type": "text",
      "placeholder": "引継ぎコード",
      "maxlength": "128"
    },
    domProps: {
      "value": (_vm.takeOverCode)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateTakeOver()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.takeOverCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password flexcenter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "carrier-activation-text",
    attrs: {
      "type": "password",
      "placeholder": "パスワード (英数半角4～16文字)",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.activateTakeOver()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "enter",
    on: {
      "click": function($event) {
        return _vm.activateTakeOver()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/svg/ar_r_login.svg",
      "alt": "login"
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('p', {
    staticClass: "carrier-activation-error-activate-takeover m0"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "return",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeDisplay()
      }
    }
  }, [_c('span', [_vm._v("戻る")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "font22"
  }, [_c('div', [_vm._v("前の端末の学習情報を引き継ぎます")]), _vm._v(" "), _c('div', [_vm._v("設定した引継ぎコードとパスワードを入力してください")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6316ca67", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-6316ca67","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CarrierActivation.vue
// module id = 871
// module chunks = 1